// extracted by mini-css-extract-plugin
export default {"label":"DatefieldComponent_label__Ut594"};